import { createContext, SetStateAction } from 'react';

export interface SelectedPolygonContextProps {
	selectedPolygon: number | null;
	setSelectedPolygon: React.Dispatch<SetStateAction<number | null>>;
}

export const SelectedPolygonContext = createContext<SelectedPolygonContextProps>({
	selectedPolygon: null,
	setSelectedPolygon: () => {},
});
